import { ReactElement } from "react";
import { useNavigate } from "react-router-dom";
import NewButton from "../../../components/Atomos/Buttons/newButton";
import { ManageDealRow } from "../../../Services/ManageDealmaker";
import ManageDealmakerTable from "./ManageDealmakerTable";

interface ManageDealmakerListProps {
  active: ManageDealRow[];
  archived: ManageDealRow[];
}

export default function ManageDealmakerList({ active, archived }: ManageDealmakerListProps): ReactElement {
  const navigate = useNavigate();
  return (
    <div className="stack">
      <div className="lead-band">
        Member Professionals can submit deals, that can be viewed by members, clients and potential customers. The extensive dealmaker database can be searched by keywords, jurisdiction, region, firm, deal type, transaction type or practice industry.
      </div>
      <div className="flex flex-wrap gap-4">
        <NewButton text="View Posted Deals" onClick={() => navigate("/dealmaker")} />
        <NewButton text="Submit a Deal" onClick={() => navigate("/manage_dealmaker?action=add")} />
      </div>
      <ManageDealmakerTable title="Manage Your Deals" rows={active} archived={false} exportTitle="Dealmaker - World Services Group" />
      <ManageDealmakerTable title="Archived Deals" rows={archived} archived exportTitle="Dealmaker (Archived) - World Services Group" />
      <div className="content-dots" aria-hidden="true"><span /><span /><span /></div>
    </div>
  );
}
